import { z } from 'zod'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

import { Account } from '../../../wallet/Account'
import { PrivateKey } from '../../../wallet/PrivateKey'

export const AccountSchema = z.object({
  address: z.string(),
  privateKey: z.string(),
})

type AccountReportText = z.infer<typeof AccountSchema>

export function mapDomainToReportText(account: Account): AccountReportText {
  return {
    address: account.getAddress().getChecksumValue(),
    privateKey: account.getPrivateKey().getHexValue(),
  }
}

export function mapReportTextToDomain(reportText: AccountReportText): Account {
  const { privateKey } = reportText
  return Account.create({
    privateKey: PrivateKey.createFromHexNumber(
      HexNumber.create({ hexNumberValue: privateKey })
    ),
  })
}
